module.exports = function () {
    return {
        restrict: 'A',
        replace: false,
        priority: 1000,
        link: function (scope, element, attrs) {
            var type = attrs.dateType;
            if (!type) return;
            switch (type) {
                case 'search_query':
                    element.attr('maxLength', '251');
                    break;
                case 'vin':
                    element.attr('maxLength', '18');
                    break;
                case 'odometer':
                    element.attr('maxLength', '11');
                    break;
                case 'general_comment':
                case 'service_comment':
                    element.attr('maxLength', '501');
                    break;
                case 'service_search_query':
                    element.attr('maxLength', '51');
                    break;
                case 'first_name':
                case 'last_name':
                    element.attr('maxLength', '51');
                    break;
                case 'phone':
                    element.attr('maxLength', '15');
                    break;
                case 'email':
                    element.attr('maxLength', '251');
                    break;
                default:
            }
        }
    };
};
